import Exception from './Exception';
/**
 * Custom Error class of type Exception.
 */
class UnsupportedOperationException extends Exception {
}
UnsupportedOperationException.kind = 'UnsupportedOperationException';
export default UnsupportedOperationException;
